import { render } from "./Selectable.vue?vue&type=template&id=21edff1e"
import script from "./Selectable.vue?vue&type=script&lang=ts"
export * from "./Selectable.vue?vue&type=script&lang=ts"
script.render = render

export default script